import { PROGRESS_PARTS } from './progressParts';
import { ProgressStyleConfig } from './types';

const baseStyle: ProgressStyleConfig['baseStyle'] = {
  track: {
    backgroundColor: 'page.plateLight',
  },
  filledTrack: {
    backgroundColor: 'brand.secondary',
    transition: 'width 0.5s',
  },
};

const SIZES = {
  xs: {
    track: {
      height: 0.5,
    },
  },
  sm: {
    track: {
      height: 1,
    },
  },
  md: {
    track: {
      height: 1.5,
    },
  },
  lg: {
    track: {
      height: 2,
    },
  },
};

const DEFAULT_PROPS = {
  size: 'md',
} as const;

export const PROGRESS_STYLE_CONFIG: ProgressStyleConfig = {
  baseStyle,
  sizes: SIZES,
  defaultProps: DEFAULT_PROPS,
  parts: PROGRESS_PARTS,
};
